import React from 'react';
import { Box } from '@material-ui/core';
import { MDSTheme, MDSTypography } from '@marqvision/mds/core';
import { useGlobalAction } from '~/hooks';
import { useLanguage } from '~/hooks';
import { LanguageEnum } from '~/constants/localizedString';
import { Logger } from '../../utils';
import FooterLink from './FooterLink';

interface IProps {
  variant: 'light' | 'dark';
  centered?: boolean;
}

const currentYear = new Date().getFullYear();

const Footer = ({ variant, centered = false }: IProps): React.ReactNode => {
  const color = (() => (variant === 'light' ? MDSTheme.palette.white : MDSTheme.palette.bluegray[800]))();

  const { showPolicy } = useGlobalAction();
  const { language } = useLanguage();

  return (
    <Box component="footer" display="flex" flexDirection="column" alignItems={centered ? 'center' : 'flex-start'}>
      <Box display="flex" gridGap="24px" marginBottom="12px">
        <FooterLink
          to="#"
          color={color}
          onClick={(e: any) => {
            e.preventDefault();

            Logger.track('clicked footer', { 'Footer Type': 'terms' });
            showPolicy('terms');
          }}
        >
          Terms
        </FooterLink>
        <FooterLink
          to="#"
          color={color}
          onClick={(e: any) => {
            e.preventDefault();

            Logger.track('clicked footer', { 'Footer Type': 'privacy' });
            showPolicy('privacy');
          }}
        >
          Privacy
        </FooterLink>
        <FooterLink
          to={`https://www.marqvision.com${language === LanguageEnum.Korean ? '/kr' : ''}/demo`}
          color={color}
          onClick={() => Logger.track('clicked footer', { 'Footer Type': 'contact' })}
        >
          Contact
        </FooterLink>
      </Box>
      <a
        href="https://www.marqvision.com/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
      >
        <MDSTypography variant="T14" weight="regular" style={{ color }}>
          © {currentYear} Marq Vision Inc.
        </MDSTypography>
      </a>
    </Box>
  );
};

export default Footer;
